module.exports = __webpack_public_path__ + "static/media/p2.d0889a95.webp";